import React, { useCallback, useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { DaysOfMonth, MONTHS_WITHOUT_ALL } from '../../../../utils/courseIncome/constaints';
import dayjs from 'dayjs';
import { Box, Stack } from '@mui/material';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { getDailyNoAttendanceStudents, getEmiPayments } from '../../../../redux/features/crdMigrationSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { EmiPaymentTableHeader } from './EmiPaymentTableHeader';
import { getProjects } from '../../../../redux/features/refundSlice';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import ViewEmiScreenshot from './ViewEmiScreenshot';

const EmiPaymentsLanding = () => {
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [project, setProject] = useState({ id: 0, name: 'All' });
  const { loading, data, meta } = useSelector((state) => state.crdMigration.emiPaymentsTable);
  const { loading: projectLoading, projectslist } = useSelector((state) => state.refund);
  const dispatch = useDispatch();
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const dispatchParams = useMemo(() => {
    return {
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sort: tableState?.sort?.field,
      sortOrder: tableState?.sort?.direction,
      fromDate,
      toDate,
      project_id: project?.id !== 0 ? project?.id : null,
    };
  }, [tableState?.page, tableState?.pageSize, tableState?.search, tableState?.sort, fromDate, toDate, project]);

  useEffect(() => {
    dispatch(getProjects());
  }, []);

  useEffect(() => {
    dispatch(getEmiPayments(dispatchParams));
  }, [dispatch, dispatchParams]);

  useEffect(() => {}, [data]);

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });
  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    setModalState({
      actionKey,
      row,
    });
  }, []);

  return (
    <GlobalWrapper title={'EMI Payments'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fullWidth={true}
        />
        <GlobalSelectFieldWithoutFormikNew
          data={projectslist}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          label={'Projects'}
          selectedDetails={project}
          setChange={setProject}
          sx={{
            maxWidth: { xs: '100%', sm: 200 },
            minWidth: { xs: '100%', sm: 180 },
          }}
        />
      </Stack>
      <Box mt={1}>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={EmiPaymentTableHeader()}
          rows={data}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          meta={meta}
          onButtonActionClick={handleButtonActionClick}
        />
      </Box>
      <Box>
        <GlobalDialog
          title={'View Screenshot'}
          open={Boolean(modalState?.actionKey)}
          setOpen={(val) => {
            if (!val) setModalState({ actionKey: '', row: null });
          }}
          closeButton={true}
          content={<ViewEmiScreenshot attachmentFileName={modalState?.row?.income_screenshot} />}
          maxWidth={'md'}
          fullWidth={true}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default EmiPaymentsLanding;
